import ReactDOM from 'react-dom'
import App from './App'
import initSentry from './helpers/sentry'
import * as serviceWorker from './serviceWorker'

initSentry()

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find the root element')

ReactDOM.render(<App />, rootElement)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
